export const RETRY_REQUEST_COUNT_BASE = 2
export const RETRY_REQUEST_DELAY_BASE = (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000)
export const RETRY_REQUEST_COUNT_BASE_POST = 0
